import { HeldEmailActionConfirmModal } from "./HeldEmailActionConfirmModal";

interface ConfirmCancelHeldEmailsModalProps {
  count: number;
  opened: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function ConfirmCancelHeldEmailsModal({
  count,
  ...dialog
}: ConfirmCancelHeldEmailsModalProps) {
  const message =
    count === 1
      ? "This email will never be delivered. This can't be undone."
      : `${count} emails will never be delivered. This can't be undone.`;
  const model = {
    ...dialog,
    actionLabel: "Cancel email",
    cancelLabel: "Keep email",
    color: "red",
    message,
    title: "Cancel queued email?",
  };
  return <HeldEmailActionConfirmModal model={model} />;
}
